import { render, staticRenderFns } from "./CentroList.vue?vue&type=template&id=19081310"
import script from "./CentroList.vue?vue&type=script&lang=js"
export * from "./CentroList.vue?vue&type=script&lang=js"
import style0 from "./CentroList.vue?vue&type=style&index=0&id=19081310&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports